import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FaHome, FaUsers, FaBoxOpen, FaArrowDown, FaArrowUp, FaTruck, FaBoxes,
  FaMoneyBillWave, FaCreditCard, FaChartBar, FaEnvelope, FaCog, FaAddressBook,
  FaChevronRight, FaUser, FaUserShield, FaUserTie,
  FaStore, FaUserFriends, FaLayerGroup, FaFileImport,
  FaList, FaPlusCircle, FaTags, FaPrint, FaRandom, FaBox, FaDollarSign,
  FaBalanceScale, FaSitemap, FaStar, FaShieldAlt,
  FaExchangeAlt, FaShoppingCart, FaCashRegister, FaFileAlt, FaTruckLoading, FaPercent,
  FaBook, FaChartLine, FaMoneyBillAlt, FaFileInvoiceDollar, FaBarcode, FaReceipt,FaPizzaSlice, FaShoppingBag,
  FaMapMarkerAlt
} from 'react-icons/fa';

const menuItems = [
  { name: 'Home', icon: <FaHome /> },
  {
    name: 'User Management',
    icon: <FaUsers />,
    subItems: [
      { name: 'Users', icon: <FaUser /> },
      { name: 'Roles', icon: <FaUserShield /> },
  
    ]
  },
  {
    name: 'Contacts',
    icon: <FaAddressBook />,
    subItems: [
   
      { name: 'Customers', icon: <FaUserFriends /> },
     
    ]
  },
 
  {
    name: 'Products',
    icon: <FaPizzaSlice />,
    subItems: [
        { name: 'Grocery Category', icon: <FaSitemap /> },
     { name: 'Grocery Product',icon: <FaShoppingBag />},
     
    ]
  },
  {
    name: 'Orders',
    icon: <FaShoppingCart />,
  },

  {
    name: 'Inventory',
    icon: <FaArrowDown />,
    subItems: [
      { name: 'GRN', icon: <FaList /> },
      { name: 'Add GRN', icon: <FaPlusCircle /> },
    ]
  },
  
 
 
    {
    name: 'Delivery',
    icon: <FaBalanceScale />,
    subItems: [
      { name: 'Assign Delivery', icon: <FaList /> },
      { name: 'Delivery Person', icon: <FaPlusCircle /> },
    ]
  },
  //   {
  //   name: 'Wallet',
  //   icon: <FaCreditCard />,
  // },
   
       {
    name: 'Banner',
    icon: <FaTags />,
  },
 


  {
    name: 'Expenses',
    icon: <FaMoneyBillWave />,
    subItems: [
      { name: 'List Expenses', icon: <FaList /> },
      { name: 'Add Expense', icon: <FaPlusCircle /> },
      { name: 'Expense Categories', icon: <FaSitemap /> }
    ]
  },
  

  
];

const navigateMap = {
  Home: '/dashboard',
  Users: '/users',
  Roles: '/roles',
  'List Products': '/product',
  'Add Product': '/add',
  'Print Labels': '/products/print-labels',
  'Grocery': '/categories',
  'List Food Items': '/food-items',
  'List Packages': '/packages' ,
  'GRN': '/grns' ,
  'Add GRN': '/grns/add' , 
  'List Expenses': '/expenses',
  'Add Expense': '/expenses/add',
  'Customers': '/Customers',
  'Subscribe Request': '/package-requests',
  'Subscribers': '/subscribers',
  'Approved Addons': '/approved-addons',
  'Addons Request': '/addon-requests',
  'Wallet': '/wallet',
  'Kitchen Dashboard': '/kitchen-dashboard',
  'Cooking Request': '/cooking-requests',
  'Banner': '/banner',
  // --- THIS IS THE CORRECTED LINE ---
  'Assign Delivery': '/AssignDelivery',
  'Delivery Person': '/delivery-persons',
  'Location': '/location',
  'Chefs': '/chefs',
  'Grocery Product': '/groceryproduct',
  'Party Product': '/partyproduct',
  'Hubs': '/hub-view',
  'Hub Requests': '/hub-requests',
  'Create hubs': '/create-hub',
  'Party': '/PartyCategories',
  'Tomorrow Meals': '/tomorrows-meals',
  'Orders': '/orders',
  'Grocery Category': '/categories',
  
};

const Sidebar = () => {
  const [expandedItems, setExpandedItems] = useState({});
  const [activeItem, setActiveItem] = useState('Home');
  const navigate = useNavigate();

  const toggleSubItems = (itemName) => {
    setExpandedItems((prev) => ({
      ...prev,
      [itemName]: !prev[itemName]
    }));
  };

  const handleNavigation = (item) => {
    setActiveItem(item.name);
    if (navigateMap[item.name]) {
      navigate(navigateMap[item.name]);
    }
  };

  return (
    <>
      <style>
        {`
          /* Sidebar Container */
          .sidebar {
            width: 280px;
            height: 100vh;
            background: linear-gradient(180deg, #1e293b 0%, #0f172a 100%);
            color: #e2e8f0;
            display: flex;
            flex-direction: column;
            font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            font-weight: 500;
            box-shadow: 4px 0 20px rgba(0, 0, 0, 0.15);
            position: relative;
            overflow: hidden;
          }

          .sidebar::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(59, 130, 246, 0.5), transparent);
          }

          /* Header */
          .sidebar-header {
            padding: 24px 20px;
            background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
            flex-shrink: 0;
            display: flex;
            align-items: center;
            gap: 16px;
            text-decoration: none;
            color: #ffffff;
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .sidebar-header::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
            transition: left 0.6s ease;
          }

          .sidebar-header:hover::before {
            left: 100%;
          }

          .sidebar-header:hover {
            background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
            transform: translateY(-1px);
          }

          .sidebar-logo {
            color: #ffffff;
            flex-shrink: 0;
            padding: 8px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 12px;
            backdrop-filter: blur(10px);
          }

          .sidebar-title {
            font-size: 22px;
            font-weight: 700;
            margin: 0;
            line-height: 1.2;
            letter-spacing: -0.025em;
          }

          /* Menu List */
          .menu-list {
            list-style: none;
            margin: 0;
            padding: 16px 0;
            flex-grow: 1;
            overflow-y: auto;
            scrollbar-width: thin;
            scrollbar-color: rgba(59, 130, 246, 0.3) transparent;
          }

          .menu-list::-webkit-scrollbar {
            width: 4px;
          }

          .menu-list::-webkit-scrollbar-track {
            background: transparent;
          }

          .menu-list::-webkit-scrollbar-thumb {
            background: rgba(59, 130, 246, 0.3);
            border-radius: 2px;
          }

          .menu-list::-webkit-scrollbar-thumb:hover {
            background: rgba(59, 130, 246, 0.5);
          }

          .menu-item-wrapper {
            margin: 2px 12px;
          }

          /* Menu Item Link */
          .menu-item {
            padding: 14px 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            text-decoration: none;
            color: #cbd5e1;
            border-radius: 12px;
            position: relative;
            overflow: hidden;
            backdrop-filter: blur(10px);
          }

          .menu-item::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(147, 51, 234, 0.1));
            opacity: 0;
            transition: opacity 0.3s ease;
            border-radius: 12px;
          }

          .menu-item:hover::before {
            opacity: 1;
          }

          .menu-item:hover {
            color: #ffffff;
            transform: translateX(4px);
            box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
          }

          .menu-item--active {
            background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
            color: #ffffff;
            font-weight: 600;
            transform: translateX(4px);
            box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
          }

          .menu-item--active::before {
            opacity: 0;
          }

          .menu-item-content {
            display: flex;
            align-items: center;
            gap: 16px;
            position: relative;
            z-index: 1;
          }

          .menu-icon {
            font-size: 18px;
            width: 20px;
            text-align: center;
            transition: transform 0.3s ease;
          }

          .menu-item:hover .menu-icon {
            transform: scale(1.1);
          }

          .menu-item-text {
            font-size: 14px;
            font-weight: 500;
            letter-spacing: -0.01em;
          }

          /* Chevron Icon */
          .chevron {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            font-size: 12px;
            opacity: 0.7;
            position: relative;
            z-index: 1;
          }
          
          .chevron--expanded {
            transform: rotate(90deg);
            opacity: 1;
          }

          .menu-item:hover .chevron {
            opacity: 1;
          }

          /* Sub-menu */
          .sub-menu-list {
            list-style: none;
            padding: 8px 0;
            margin: 8px 0 0 0;
            background: rgba(15, 23, 42, 0.6);
            border-radius: 12px;
            backdrop-filter: blur(20px);
            border: 1px solid rgba(59, 130, 246, 0.1);
            overflow: hidden;
            animation: slideDown 0.3s ease-out;
          }

          @keyframes slideDown {
            from {
              opacity: 0;
              transform: translateY(-10px);
              max-height: 0;
            }
            to {
              opacity: 1;
              transform: translateY(0);
              max-height: 500px;
            }
          }

          .sub-menu-item {
            padding: 12px 20px 12px 52px;
            display: flex;
            align-items: center;
            gap: 12px;
            cursor: pointer;
            text-decoration: none;
            color: #94a3b8;
            font-weight: 400;
            font-size: 13px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            position: relative;
            border-radius: 8px;
            margin: 2px 8px;
          }

          .sub-menu-item::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 2px;
            height: 0;
            background: linear-gradient(180deg, #3b82f6, #8b5cf6);
            transition: height 0.3s ease;
            border-radius: 1px;
          }

          .sub-menu-item:hover::before {
            height: 60%;
          }

          .sub-menu-item:hover {
            color: #ffffff;
            background: rgba(59, 130, 246, 0.1);
            transform: translateX(4px);
          }

          .sub-menu-item--active {
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(147, 51, 234, 0.2));
            color: #ffffff;
            font-weight: 500;
            transform: translateX(4px);
          }

          .sub-menu-item--active::before {
            height: 60%;
          }

          .sub-menu-item .menu-icon {
            font-size: 14px;
            opacity: 0.8;
            transition: all 0.3s ease;
          }

          .sub-menu-item:hover .menu-icon,
          .sub-menu-item--active .menu-icon {
            opacity: 1;
            transform: scale(1.1);
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .sidebar {
              width: 260px;
            }
            
            .sidebar-title {
              font-size: 20px;
            }
          }

          /* Smooth scrolling */
          .menu-list {
            scroll-behavior: smooth;
          }

          /* Focus states for accessibility */
          .menu-item:focus,
          .sub-menu-item:focus {
            outline: 2px solid #3b82f6;
            outline-offset: 2px;
          }
        `}
      </style>

      <div className="sidebar">
        <a href="/dashboard" className="sidebar-header">
          <div className="sidebar-logo">
            <FaBoxOpen size={24} />
          </div>
          <h2 className="sidebar-title">SUGAAN FOODS</h2>
        </a>

        <ul className="menu-list">
          {menuItems.map((item, index) => {
            const isExpanded = expandedItems[item.name];
            const isActive = activeItem === item.name || (item.subItems && item.subItems.some(sub => activeItem === sub.name));

            return (
              <React.Fragment key={index}>
                <li className="menu-item-wrapper">
                  <div 
                    className={`menu-item ${isActive ? 'menu-item--active' : ''}`}
                    onClick={() => {
                      if (item.subItems) {
                        toggleSubItems(item.name);
                      } else {
                        handleNavigation(item);
                      }
                    }}
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        if (item.subItems) {
                          toggleSubItems(item.name);
                        } else {
                          handleNavigation(item);
                        }
                      }
                    }}
                  >
                    <div className="menu-item-content">
                      <span className="menu-icon">{item.icon}</span>
                      <span className="menu-item-text">{item.name}</span>
                    </div>
                    {item.subItems && (
                      <FaChevronRight 
                        className={`chevron ${isExpanded ? 'chevron--expanded' : ''}`} 
                      />
                    )}
                  </div>

                  {item.subItems && isExpanded && (
                    <ul className="sub-menu-list">
                      {item.subItems.map((subItem, i) => (
                        <li 
                          key={i}
                          className={`sub-menu-item ${activeItem === subItem.name ? 'sub-menu-item--active' : ''}`}
                          onClick={() => handleNavigation(subItem)}
                          tabIndex={0}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                              e.preventDefault();
                              handleNavigation(subItem);
                            }
                          }}
                        >
                          <span className="menu-icon">{subItem.icon}</span>
                          <span>{subItem.name}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default Sidebar;